import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { QRCodeCanvas } from "qrcode.react";
import "./TwoFactorSetupPage.css";
import { Helmet } from "react-helmet";

export default function TwoFactorSetupPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState(""); // User email for 2FA setup
  const [otp, setOtp] = useState("");
  const [setupComplete, setSetupComplete] = useState(false);
  const [otpauthUrl, setOtpauthUrl] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleStartSetup = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // Call backend to generate secret and otpauth URL
      const res = await axios.post("http://localhost:5050/api/2fa/setup", { email });
      setOtpauthUrl(res.data.otpauth);
      setSetupComplete(false); // show QR code and input
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || "Failed to start 2FA setup");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post("http://localhost:5050/api/2fa/verify", { email, otp });
      if (res.data.success) {
        setSetupComplete(true);
        setTimeout(() => navigate("/login"), 1500); // Redirect to login after success
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || "OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="setup-2fa-wrapper">
      <Helmet>
        <title>RCM | 2FA Setup</title>
      </Helmet>

      <div className="setup-2fa-box">
        <h2>Two-Factor Authentication Setup</h2>

        {!otpauthUrl && (
          <form onSubmit={handleStartSetup}>
            <label htmlFor="email">Enter your email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? "Generating..." : "Start Setup"}
            </button>
          </form>
        )}

        {otpauthUrl && !setupComplete && (
          <>
            <p>Scan this QR code with your 2FA app (Google Authenticator, Authy, etc.):</p>
            <QRCodeCanvas value={otpauthUrl} size={200} />

            <p>
              Or manually enter this key:{" "}
              <strong>{otpauthUrl.split("secret=")[1].split("&")[0]}</strong>
            </p>

            <form onSubmit={handleVerifyOTP}>
              <label htmlFor="otp">Enter OTP from your app</label>
              <input
                id="otp"
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
              <button type="submit" disabled={loading}>
                {loading ? "Verifying..." : "Verify OTP"}
              </button>
            </form>
          </>
        )}

        {setupComplete && <p>2FA setup complete! Redirecting to login...</p>}

        {error && <p className="setup-2fa-error">{error}</p>}
      </div>

      <footer>
        <p>&copy; 2026 Rebus Capital Management LLC | All rights reserved.</p>
      </footer>
    </div>
  );
}
